{
  "DATA_ASSISTANT": {
    "TITLE": "Data-avustaja",
    "NEW_CONVERSATION": "+ Uusi",
    "LOADING": "Ladataan...",
    "LOADING_MESSAGES": "Ladataan viestejä...",
    "THINKING": "Ajattelee...",
    "UNTITLED": "Nimetön keskustelu",
    "NO_CONVERSATIONS": "Ei vielä keskusteluja. Aloita napsauttamalla ”+ Uusi”.",
    "EMPTY_STATE": "Valitse keskustelu tai luo uusi aloittaaksesi.",
    "PLACEHOLDER": "Mitä voin selvittää sinulle?",
    "SHOW_SQL": "Näytä SQL",
    "NO_ROWS": "Rivejä ei palautunut.",
    "DELETE": "×",
    "DELETE_CONFIRM": "Poista keskustelu",
    "DELETE_CONFIRM_DESCRIPTION": "Haluatko varmasti poistaa tämän keskustelun? Tätä toimintoa ei voi perua.",
    "DELETE_CONFIRM_YES": "Poista",
    "REPORTS": "Raportit",
    "SAVE_TO_REPORT": "Tallenna raporttiin",
    "NEW_REPORT": "Uusi raportti",
    "REPORT_NAME": "Raportin nimi",
    "NO_REPORTS": "Ei vielä tallennettuja raportteja",
    "REPORTS_EMPTY_STATE": "Valitse raportti tai luo uusi.",
    "REPORT_SAVED": "Tallennettu raporttiin",
    "DELETE_REPORT_CONFIRM": "Poista raportti",
    "DELETE_REPORT_CONFIRM_DESCRIPTION": "Haluatko varmasti poistaa tämän raportin? Kaikki tallennetut kohteet poistetaan.",
    "DELETE_ITEM_CONFIRM": "Poista kohde",
    "DELETE_ITEM_CONFIRM_DESCRIPTION": "Haluatko varmasti poistaa tämän kohteen raportista?",
    "EXPORT_CSV": "Vie CSV-muodossa",
    "REFRESH": "Päivitä",
    "QUERY_RUNNING": "Suoritetaan kyselyä...",
    "QUERY_FAILED": "Kysely epäonnistui",
    "AUTO_REFRESH": "Automaattinen päivitys",
    "AUTO_REFRESH_NONE": "Manuaalinen",
    "AUTO_REFRESH_30S": "30 sekuntia",
    "AUTO_REFRESH_1M": "1 minuutti",
    "AUTO_REFRESH_5M": "5 minuuttia",
    "AUTO_REFRESH_10M": "10 minuuttia",
    "EDIT_MESSAGE": "Muokkaa viestiä",
    "RENAME_REPORT": "Nimeä raportti uudelleen",
    "RENAME_ITEM": "Nimeä kohde uudelleen",
    "MOVE_UP": "Siirrä ylös",
    "MOVE_DOWN": "Siirrä alas",
    "COLLABORATORS": {
      "BUTTON": "Yhteiskäyttäjät",
      "TITLE": "Raportin yhteiskäyttäjät",
      "DESCRIPTION": "Valitse, mitkä edustajat ja tiimit voivat nähdä tämän raportin.",
      "AGENTS": "Edustajat",
      "TEAMS": "Tiimit",
      "SELECT_AGENTS": "Valitse edustajat",
      "SELECT_TEAMS": "Valitse tiimit",
      "SAVE": "Tallenna",
      "SAVED": "Yhteiskäyttäjät päivitetty",
      "SAVE_FAILED": "Yhteiskäyttäjien päivitys epäonnistui"
    }
  }
}
